import React, { useContext, useEffect, useState } from "react";
import { Button, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { ItemDropdownMenu, LabelSwitch } from "./";
import { api, constants, dateHelpers, helpers, UserContext } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import Select from "react-select";
import SortHeader from "./SortHeader";
import ServiceThreadSpinner from "./ServiceThreadSpinner";
import classNames from 'classnames';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Date requirements for radio buttons
let weekEndDate;
let weekStartDate;
let today = new Date();
let tomorrow = new Date();
let tomorrowDate = dateHelpers.toLongDateString(tomorrow.setDate(today.getDate() + 1));
let weekday = today.getDay();
let monthDay = today.getDate();

let date = new Date();
let dateEnd = new Date();
switch (weekday) {
   case 0:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay + 1));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 5));
      break;
   case 1:
      weekStartDate = dateHelpers.toLongDateString(date);
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 4));
      break;
   case 2:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 1));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 3));
      break;
   case 3:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 2));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 2));
      break;
   case 4:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 3));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 1));
      break;
   case 5:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 4));
      weekEndDate = dateHelpers.toLongDateString(dateEnd);
      break;
   case 6:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay + 2));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 6));
      break;
   default:
      break;
}

export default function ReceivingLabelManager() {
   const WGT_MODEL = { index: 0, id: 0, po: "", item: "", site: "", numLabels: 0, toKg: false, totalWgt: 0, wgt: 0 };
   const navigate = useNavigate();
   const userCtx = useContext(UserContext);
   const { currentUser } = userCtx;
   const currentDate = dateHelpers.toLongDateString(new Date());
   const [data, setData] = useState();
   const [downloading, setDownloading] = useState(false);
   const [includeClosed, setIncludeClosed] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [periodType, setPeriodType] = useState("current_week");
   const [printers, setPrinters] = useState([]);
   const [printToPrinter, setPrintToPrinter] = useState(true);
   const [searchType, setSearchType] = useState("po");
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [selectedVendor, setSelectedVendor] = useState();
   const [sortDirection, setSortDirection] = useState("asc");
   const [sortField, setSortField] = useState("itemNumber");
   const [textSearchValue, setTextSearchValue] = useState("");
   const [vendors, setVendors] = useState([]);
   const [weights, setWeights] = useState(null);
   const [working, setWorking] = useState(false);

   useEffect(() => {
      document.title = `Receiving Label Manager`
      getVendors();
      getPrinters();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   useEffect(() => {
      getPos();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [periodType]);

   useEffect(() => {
      if (loaded) {
         getPos();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [sortField, sortDirection]);

   function createInventoryLabels() {
      let payload = {
         FromReceivingManager: true
      };
      if (!selectedPrinter) {
         toast.error("Please pick a printer.");
         return;
      } else {
         payload.printerId = selectedPrinter.value;
         payload.printerName = selectedPrinter.label;
      }

      let quit = false;
      let labels = [];
      _.forEach(weights, function (value, index) {
         if (quit) return;
         let item = value;
         if (_.trim(item.wgt) === "") {
            toast.error("All weight entries are required");
            labels = [];
            quit = true;
            return;
         }
         if (isNaN(item.wgt)) {
            toast.error("All weight entries must be numeric");
            labels = [];
            quit = true;
            return;
         }
         if (item.wgt <= 0) {
            toast.error("All weight entries must be > 0");
            labels = [];
            quit = true;
            return;
         }
         if (!isNaN(item.wgt)) {
            labels.push({
               ItemNumber: item.item,
               LbsToKg: item.toKg,
               NumberOfLabels: item.numLabels,
               PONumber: item.po,
               SiteCode: item.site,
               TotalLbs: item.totalWgt,
               Weight: item.wgt
            })
         }
      });
      if (labels.length < 1) return;

      payload.Labels = labels;
      payload.PrintToPrinter = printToPrinter;
      setDownloading(true);
      if (printToPrinter) {
         api
            .post("Printer/PrintReceivingLabels", payload)
            .then((response) => {
               if (response && response.data && response.data.success) {
                  toast.success("Labels were sent to the printer");
                  resetLabelCount();
                  setWeights(null);
               } else {
                  toast.warning(response?.data?.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setDownloading(false));
      } else {
         api.postDownloadBinary(
            "Printer/PrintReceivingLabels",
            payload,
            constants.MIME_TYPES.pdf,
            `Receiving_Labels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`
         )
         .then((response) => {
            if (response?.data === false) {
               toast.error(response.message);
            }
            else {
               resetLabelCount();
               setWeights(null);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setDownloading(false));
      }
   }

   function CreatePayload() {
      let payload = {
         ItemNumber: "",
         ItemDescription: "",
         VendorId: searchType === "vendor" ? selectedVendor.value : "",
         PONumber: searchType === "po" ? textSearchValue : "",
         AccountIndex: 0,
         ShowOpenOnly: !includeClosed,
         Container: searchType === "container" ? textSearchValue : "",
         SortField: sortField,
         SortDirection: sortDirection,
         StartPODate: null,
         EndPODate: null
      };

      if (periodType === "today") {
         let today = new Date(currentDate);
         payload.StartPODate = dateHelpers.formatDateForServer(today);
         payload.EndPODate = dateHelpers.formatDateForServer(today);
      }
      else if (periodType === "tomorrow") {
         let tomorrow = new Date(tomorrowDate);
         payload.StartPODate = dateHelpers.formatDateForServer(tomorrow);
         payload.EndPODate = dateHelpers.formatDateForServer(tomorrow);
      }
      else {  // current_week
         let weekStart = new Date(weekStartDate);
         let weekEnd = new Date(weekEndDate);
         payload.StartPODate = dateHelpers.formatDateForServer(weekStart);
         payload.EndPODate = dateHelpers.formatDateForServer(weekEnd);
      }

      return payload;
   }

   const ExportToExcel = () => {
      setWorking(true);
      api
         .postGetBlob(`Purchasing/ExportReceivingLabels`, CreatePayload())
         .then((r) => {
            if (r.data.success === false) {
               if (_.isString(r?.data?.message)) {
                  toast.error(r?.data?.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = `ReceivingLabels.xlsx`;
               helpers.downloadExport(
                  r.data,
                  XLSX_FILENAME,
                  constants.MIME_TYPES.xlsx
               );
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler)
         .finally(setWorking(false));
   }

   function formatPrinters(data) {
      let printerArr = data.labels;
      let list = _.map(printerArr, (x) => {
         return { label: x.nameOnly, value: x.id }
      });
      return list;
   }

   function getPos() {
      setIsLoading(true);
      api
         .fetch("Purchasing/POSearchReceiving", CreatePayload())
         .then((response) => {
            if (response && response.data.success) {
               setData(response.data.message);
               setLoaded(true);
            } else {
               toast.error("Failed to get purchase orders.")
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsLoading(false));
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response) {
               setPrinters(formatPrinters(response.data));
            } else {
               toast.error("Failed to get printers.");
            }
         })
         .catch(api.catchHandler);
   }

   function getVendors() {
      api
         .fetch("Reference/GetVendorList")
         .then((response) => {
            if (response) {
               setVendors(response.data.vendorList);
            } else {
               toast.error("Failed to get companies");
            }
         })
         .catch(api.catchHandler)
   }

   const handleFocus = (event) => event.target.select();

   function initWeights() {
      if (!_.filter(data, 'NumberOfLabels').length) {
         toast.error("No Labels have a quantity.");
         return;
      }
      let quit = false;
      let labels = [];
      let idx = 1;
      _.forEach(data, function (value, index) {
         if (quit) return;
         let item = value;
         if (_.trim(item.NumberOfLabels) !== "" && isNaN(item.NumberOfLabels)) {
            toast.error("Each label quantity must be a number.");
            labels = [];
            quit = true;
            return;
         }
         if (!isNaN(item.NumberOfLabels) && item.NumberOfLabels !== 0) {
            if (!item.totalLbs || (_.trim(item.totalLbs) !== "" && isNaN(item.totalLbs))) {
               toast.error("The total weight for labels with quantities must be numeric.");
               labels = [];
               quit = true;
               return;
            }
            for (let i = 0; i < item.NumberOfLabels; i++) {
               let changes = Object.assign({}, WGT_MODEL);
               changes.index = idx++;
               changes.id = i + 1;
               changes.item = item.stItemNumber;
               changes.numLabels = item.NumberOfLabels;
               changes.po = item.poNumber;
               changes.site = item.siteCode;
               changes.toKg = item.lbsToKg;
               changes.totalWgt = item.totalLbs;
               labels.push(changes);
            }
         }
      });
      if (labels.length > 0)
         setWeights(labels);
   }

   function isDecimalTotal(str) {
      // One to fifteen digits + optional decimal up to 4 places
      return (/^[0-9]{1,15}(\.[0-9]{0,4})?$/).test(str);
   }

   function isDecimalVal(str) {
      // One to five digits + optional decimal up to 4 places
      return (/^[0-9]{1,5}(\.[0-9]{0,4})?$/).test(str);
   }

   function onDateOptionChange(option) {
      setPeriodType(option);
   }

   function onKGChange(field, value, index) {
      let newList = _.assign([], data);
      newList[index][field] = value;
      setData(newList);
   }

   function onLabelQuantityChange(field, value, index) {
      let isTotal = (field === "totalLbs");
      let parsedValue = isTotal ? parseFloat(value) : parseInt(value, 10);
      let newList = _.assign([], data);

      if (isTotal) { // Total LBS for labels to print on this row
         let parsedField = parseFloat(newList[index][field]);
         let isExistingBad = (isNaN(parsedField) || parsedField < 0 || !isDecimalTotal(newList[index][field]));
         if (value === undefined || value === "" || isNaN(parsedValue) || parsedValue < 0) {
            // Total LBS entered is not a number or is empty.
            if (isExistingBad || value === "") {
               // Existing value wasn't good or user wants to reset so reset all row entries
               toast.info("Total Lbs must be numeric. Resetting row.");
               newList[index]["NumberOfLabels"] = "";
               value = "";
            }
            else {
               // Existing value is good and user is not resetting, so just leave everything alone
               toast.info("Total Lbs must be numeric with no more than 4 decimals");
               value = parsedField;
            }
         }
         else if (!isDecimalTotal(value)) {
            if (isExistingBad) {
               // Existing value wasn't good so reset all row entries
               toast.info("Total Lbs must be numeric with no more than 4 decimals. Resetting row.");
               newList[index]["NumberOfLabels"] = "";
               value = "";
            }
            else {
               //toast.info("Total Lbs must be numeric with no more than 4 decimals");
               value = parsedField;
            }
         }
      }
      else { // Number of labels to print
         let parsedField = parseInt(newList[index][field]);
         let isExistingBad = (isNaN(parsedField) || parsedField < 0 || !constants.IsPositiveNumber(newList[index][field]));
         if (value === undefined || value === "" || isNaN(parsedValue) || parsedValue < 0) {
            if (isExistingBad || value === "") {
               // Existing value wasn't good or user wants to reset so reset all row entries
               toast.info("Number of labels must be numeric. Resetting row.");
               newList[index]["totalLbs"] = "";
               value = "";
            }
            else {
               // Existing value is good and user is not resetting, so just leave everything alone
               toast.info("Number of labels must be numeric.");
               value = parsedField;
            }
         }
         else if (!constants.IsPositiveNumber(value)) {
            if (isExistingBad) {
               // Existing value wasn't good so reset all row entries
               toast.info("Number of labels must be numeric. Resetting row.");
               newList[index]["totalLbs"] = "";
               value = "";
            }
            else {
               //toast.info("Number of labels must be numeric.");
               value = parsedField;
            }
         }
      }

      newList[index][field] = value;
      setData(newList);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc");
      } else {
         setSortDirection(direction);
      }
   }

   function onWeightChange(field, value, index) {
      let newList = _.assign([], weights);
      let parsedValue = parseFloat(value);
      if (value === undefined || value === "" || !isDecimalVal(value) || parsedValue < 0) {
         let parsedField = parseFloat(newList[index][field]);
         if (isNaN(parsedField) || parsedField < 0 || !isDecimalVal(newList[index][field]))
            value = "0"; // Existing value wasn't good either so reset
         else
            value = parsedField; // Existing value is good, just keep it
         toast.info("Weight must be numeric with no more than 4 decimals");
      }
      else {
         let kgValue = newList[index].toKg ? constants.GetPoundsFromKgs(parsedValue) : parsedValue;
         if (kgValue > 25000) {
            value = newList[index].toKg ? "11339.8227" : "25000";
            toast.warning("Weight cannot exceed 25,000 lbs or 11,339.8227 kgs");
         }
      }
      newList[index][field] = value;
      setWeights(newList);
   }

   function resetLabelCount() {
      let labels = [];
      _.forEach(data, function (value, index) {
         let item = value;
         item.NumberOfLabels = 0;
         labels.push(item);
      });
      setData(labels);
   }

   return (
      <DesktopContainer screenName="Receiving Labels">
         <Row className="filter-header mt-3 d-flex justify-content-center align-items-center">
            <Col xs="8">
               <Row className="mt-4 d-flex align-items-center">
                  <Col xs="3">
                     <Label check className="mx-2" style={{ color: "white", fontSize: "1.25rem" }}>
                        <Input type="radio" name="po-radio" value="po" className="mx-1" checked={searchType === "po"} onChange={(e) => setSearchType(e.target.value)} />
                        PO #:
                     </Label>
                  </Col>
                  <Col xs="7">
                     {searchType === "po" ? (
                        <Input
                           type="text"
                           value={textSearchValue}
                           onChange={(e) => setTextSearchValue(e.target.value)}
                        />
                     ) : null}
                  </Col>
               </Row>
               <Row className="mt-4 d-flex align-items-center">
                  <Col xs="3">
                     <Label check className="mx-2" style={{ color: "white", fontSize: "1.25rem" }}>
                        <Input type="radio" name="vendor-radio" value="vendor" className="mx-1" checked={searchType === "vendor"} onChange={(e) => setSearchType(e.target.value)} />
                        Vendor (YTD):
                     </Label>
                  </Col>
                  <Col xs="7">
                     {searchType === "vendor" ? (
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={vendors}
                           value={selectedVendor}
                           onChange={(e) => setSelectedVendor(e)}
                        />
                     ) : null}
                  </Col>
               </Row>
               <Row className="mt-4 d-flex align-items-center">
                  <Col xs="3">
                     <Label check className="ms-2" style={{ color: "white", fontSize: "1.25rem" }}>
                        <Input type="radio" name="container-radio" value="container" className="mx-1" checked={searchType === "container"} onChange={(e) => setSearchType(e.target.value)} />
                        Container:
                     </Label>
                  </Col>
                  <Col xs="7">
                     {searchType === "container" ? (
                        <Input
                           type="text"
                           value={textSearchValue}
                           onChange={(e) => setTextSearchValue(e.target.value)}
                        />
                     ) : null}
                  </Col>
               </Row>

               <Row className="mt-4 d-flex align-items-center">
                  <Col xs="3">
                     <Label check className="ms-2 float-end" style={{ color: "white", fontSize: "1.25rem" }}>
                        Promised Date:
                     </Label>
                  </Col>
                  <Col xs="7">
                     <FormGroup check inline>
                        <Label check className="text-white">
                           <Input
                              type="radio"
                              name="radio1"
                              checked={periodType === 'current_week'}
                              onChange={e => onDateOptionChange('current_week')}
                           /> Current Week
                        </Label>
                     </FormGroup>
                     <FormGroup check inline>
                        <Label check className="text-white">
                           <Input
                              type="radio"
                              name="radio1"
                              checked={periodType === 'today'}
                              onChange={e => onDateOptionChange('today')}
                           /> Today
                        </Label>
                     </FormGroup>
                     <FormGroup check inline>
                        <Label check className="text-white">
                           <Input
                              type="radio"
                              name="radio1"
                              checked={periodType === 'tomorrow'}
                              onChange={e => onDateOptionChange('tomorrow')}
                           /> Tomorrow
                        </Label>
                     </FormGroup>
                  </Col>
               </Row>


               <Row className="mt-4 d-flex align-items-center">
                  <Col xs="10">
                     <Button
                        className="shredButton me-3"
                        onClick={() => getPos()}
                     >
                        SEARCH PURCHASE ORDERS
                     </Button>
                     <Label style={{ color: "white", fontSize: "1.25rem" }}>
                        <Input
                           className="mx-2"
                           type="checkbox"
                           defaultChecked={false}
                           value={includeClosed}
                           onChange={(e) => setIncludeClosed(e.target.checked)}
                        />
                        &nbsp;Include Closed PO's?
                     </Label>
                  </Col>
               </Row>
            </Col>
         </Row>
         {data ? (
            <ServiceThreadSpinner on={isLoading}>
               <br />
               {!weights ? (
                  <Row className={"mb-2"}>
                     <Col xs={{ offset: 6, size: 6 }} className="transparent-background">
                        <Button
                           title="Download as .xlsx"
                           className="shredButtonExcel float-end ms-2"
                           onClick={ExportToExcel}
                           disabled={working}
                        >
                           <FontAwesomeIcon icon="file-excel" size="lg" />
                        </Button>
                     </Col>
                  </Row>
               ) : null}
               {!weights ? (
                  <Row className="mt-3 d-flex justify-content-center">
                     <Col xs="12">
                        <Table size="sm" className="data-table">
                           <thead className="table-header">
                              <tr>
                                 <th>
                                    <SortHeader
                                       displayName={"PO #"}
                                       field={"poNumber"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "poNumber"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Containers"}
                                       field={"containers"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "containers"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"PO Date"}
                                       field={"documentDate"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "documentDate"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Vendor"}
                                       field={"vendorWithName"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "vendorWithName"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Item"}
                                       field={"itemNumber"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "itemNumber"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Vendor Item"}
                                       field={"vendorItem"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "vendorItem"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={<span>Qty<br />Ordered</span>}
                                       field={"orderQty"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "orderQty"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={<span>Qty<br />Received</span>}
                                       field={"qtyShipped"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "qtyShipped"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={<span>Required<br />Date</span>}
                                       field="LineRequiredDate"
                                       sortDirection={sortDirection}
                                       sorted={sortField === "LineRequiredDate"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={<span>Current<br />Promised<br />Date</span>}
                                       field="LinePromisedDate"
                                       sortDirection={sortDirection}
                                       sorted={sortField === "LinePromisedDate"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 <th>
                                    <SortHeader
                                       displayName={"Status"}
                                       field={"lineStatusText"}
                                       sortDirection={sortDirection}
                                       sorted={sortField === "lineStatusText"}
                                       callback={onSortChange}
                                    />
                                 </th>
                                 {/* Only show edit columns based on permissions */}
                                 {(currentUser.isAdmin
                                    || currentUser.isPowerUser
                                    || currentUser.isInventoryEdit
                                    || currentUser.isWarehouseEdit
                                 ) && (
                                    <th className="width95px">Labels</th>
                                 )}
                                 {(currentUser.isAdmin
                                    || currentUser.isPowerUser
                                    || currentUser.isInventoryEdit
                                    || currentUser.isWarehouseEdit
                                 ) && (
                                    <th className="width135px">Total Lbs</th>
                                 )}
                                 {(currentUser.isAdmin
                                    || currentUser.isPowerUser
                                    || currentUser.isInventoryEdit
                                    || currentUser.isWarehouseEdit
                                 ) && (
                                    <th className="width40px">In KG</th>
                                 )}
                              </tr>
                           </thead>
                           <tbody>
                              {_.map(data, (d, index) => {
                                 return (
                                    <tr key={index}>
                                       <td className="data-cell">
                                          <span
                                             className="shredLink fw-bold"
                                             onClick={() => navigate(`/attachments/${constants.ATTACHMENT_TYPES.PurchaseOrder}/${d.poNumber}`)}
                                          >{d.poNumber}
                                          </span>
                                       </td>
                                       <td className="data-cell">{d.containers}</td>
                                       <td className="data-cell">
                                          <span>
                                             {dateHelpers.toLongDateString(d.documentDate)}
                                          </span>
                                       </td>
                                       <td className="data-cell">
                                          <span>
                                             {d.vendorWithName}
                                          </span>
                                       </td>
                                       <ItemDropdownMenu
                                          itemNumber={d.stItemNumber}
                                          itemDescription={d.stItemWithDescription}
                                       />
                                       <td className="data-cell">{d.vendorItemNumber}</td>
                                       <td className="data-cell">{d.orderQty}</td>
                                       <td className="data-cell">{d.qtyShipped}</td>
                                       <td className={classNames("data-cell", { "fw-bold text-danger": Date.parse(d.lineRequiredDate) < Date.parse(d.linePromisedDate) })}>
                                          {dateHelpers.toLongDateString(d.lineRequiredDate)}
                                       </td>
                                       <td className="data-cell">{dateHelpers.toLongDateString(d.linePromisedDate)}</td>
                                       <td className="data-cell">{d.lineStatusText}</td>
                                       {/* Only show edit columns based on permissions */}
                                       {(currentUser.isAdmin
                                          || currentUser.isPowerUser
                                          || currentUser.isInventoryEdit
                                          || currentUser.isWarehouseEdit
                                       ) && (
                                          <td className="data-cell">
                                             <Input
                                                type="text"
                                                value={data[index]?.NumberOfLabels}
                                                onChange={(e) => onLabelQuantityChange(
                                                   "NumberOfLabels",
                                                   e.target.value,
                                                   index
                                                )}
                                             />
                                          </td>
                                       )}
                                       {(currentUser.isAdmin
                                          || currentUser.isPowerUser
                                          || currentUser.isInventoryEdit
                                          || currentUser.isWarehouseEdit
                                       ) && (
                                          <td className="data-cell">
                                             <Input
                                                type="text"
                                                value={data[index]?.totalLbs}
                                                onChange={(e) => onLabelQuantityChange(
                                                   "totalLbs",
                                                   e.target.value,
                                                   index
                                                )}
                                             />
                                          </td>
                                       )}
                                       {(currentUser.isAdmin
                                          || currentUser.isPowerUser
                                          || currentUser.isInventoryEdit
                                          || currentUser.isWarehouseEdit
                                       ) && (
                                          <td className="data-cell">
                                             <Input
                                                type="checkbox"
                                                defaultChecked={false}
                                                className="mx-2"
                                                onChange={(e) => onKGChange(
                                                   "lbsToKg",
                                                   e.target.checked,
                                                   index
                                                )}
                                             />
                                          </td>
                                       )}
                                    </tr>
                                 );
                              })}
                           </tbody>
                        </Table>
                        {(currentUser.isAdmin
                           || currentUser.isPowerUser
                           || currentUser.isInventoryEdit
                           || currentUser.isWarehouseEdit
                        ) && (
                           <Row className="mt-3">
                              <Col xs="11" style={{ textAlign: "left", marginRight: "5px" }}>
                                 <Button
                                    title="Add Weights"
                                    className="shredButton float-end ms-2"
                                    onClick={() => initWeights()}
                                 >Add Weight(s)
                                 </Button>
                              </Col>
                           </Row>
                        )}
                     </Col>
                  </Row>
               ) : null}
               {weights ? (
                  <div>
                     <br />
                     <Table size="sm" className="data-table">
                        <thead className="table-header">
                           <tr>
                              <th>PO #</th>
                              <th>Item</th>
                              <th>Location</th>
                              <th>#</th>
                              <th>In Kg</th>
                              <th>Total Weight</th>
                              <th>Weight</th>
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(weights, (datum, index) => {
                              return (
                                 <tr key={index}>
                                    <td className="data-cell">{datum.po}</td>
                                    <td className="data-cell">{datum.item}</td>
                                    <td className="data-cell">{datum.site}</td>
                                    <td className="data-cell">{datum.id}</td>
                                    <td className="data-cell">
                                       {datum.toKg ? <FontAwesomeIcon className="" icon="check" /> : ""}
                                    </td>
                                    <td className="data-cell">{helpers.formatWithDecimalPlaces(datum.totalWgt)}</td>
                                    <td className="data-cell">
                                       <Input
                                          type="number"
                                          className="no-spinner"
                                          value={weights[index]?.wgt}
                                          onFocus={handleFocus}
                                          onChange={(e) => onWeightChange("wgt", e.target.value, index)}
                                       />
                                    </td>
                                 </tr>
                              );
                           })}
                        </tbody>
                     </Table>
                     <br />
                     <Row className="mt-3 d-flex justify-content-center align-items-center">
                        <Col xs="8" className="align-items-center">
                           <h5 className="text-center" style={{ color: "red" }}>Please be patient when printing a larger number of labels.</h5>
                        </Col>
                     </Row>
                     <Row className="mt-3 d-flex justify-content-center align-items-center">
                        <Col className="centerRight" xs="5" style={{ textAlign: "left", marginRight: "5px" }}>
                           <label htmlFor="printer-list" style={{ marginRight: '10px' }}>Printers:</label>
                           <Select id="printer-list"
                              styles={{
                                 container: (provided) => ({
                                    ...provided,
                                    display: 'inline-block',
                                    width: '300px'
                                 })
                              }}
                              classNamePrefix="serviceThreadSelect"
                              options={printers}
                              value={selectedPrinter}
                              onChange={(e) => setSelectedPrinter(e)}
                              isMulti={false}
                              isClearable={false}
                           />
                        </Col>
                        <Col xs="6">
                           <LabelSwitch                              
                              displayName="Print to Printer?"
                              buttonLabel="CREATE INVENTORY LABELS"
                              onChangeCallback={(e) => setPrintToPrinter(e)}
                              onButtonClick={createInventoryLabels}
                              disabled={downloading}
                           />
                        </Col>
                     </Row>
                  </div>                  
               ) : null}
            </ServiceThreadSpinner>
         ) : null}
      </DesktopContainer>
   );
}
